import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import React, { useState } from "react";
import { PageHeader } from "../../../../../components/page-header";
import { EmptyData } from "../../../../../components/empty/emptyData";
import { useOwnershipTypes } from "./useOwnershipTypes"; // Updated hook name
import { AddOwnershipTypesModal } from "./AddOwnershipTypesModal"; // Updated modal component name
import { useGetDataOnScroll } from "../../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetOwnershipTypesListQuery } from "../../../../../redux/api/handBooksApi/ownershipTypesApi"; // Updated API import
import { useTranslation } from "react-i18next";
import { ContentPartFilter } from "../../../../../components/content-part/ContentPartFilter";
import { EntInitialFilterName } from "../../../../../models/filters/initialFilterName";
import _ from "lodash";
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";
import { useForm } from "antd/es/form/Form";
import { FilterByNameHB } from "../../../../../components/filterByNameHB/FilterByNameHB";

enum FormField {
  name
}

export const OwnershipTypes = () => {
  const [form] = useForm();
  const [modal, contextHolder] = Modal.useModal();
  const { t } = useTranslation();
  const [selectedItem, setSelectedItem] = useState<EntDirectoryInfoName>(new EntDirectoryInfoName());
  const [showModal, setShowModal] = useState<boolean>(false);

  const [getArchiveFolders] = useLazyGetOwnershipTypesListQuery();
  const {
	fetching,
	data,
	access,
	filter,
	totalItems,
	setFilter,
	setData,
	setCurrentPage,
	setFetching
  } = useGetDataOnScroll<EntDirectoryInfoName, EntInitialFilterName>({
	initialFilter: new EntInitialFilterName(),
	query: getArchiveFolders
  });

  const { onAddOwnershipTypes, onEditOwnershipTypes, onDeleteOwnershipTypes } = useOwnershipTypes(modal, () => {
	searchHandleClick()
  });  // Updated hook name
  const [height, setHeight] = useState<number>(0);

  const openAddModal = (role: EntDirectoryInfoName) => {
	setSelectedItem(role);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntInitialFilterName => {
	let item: EntInitialFilterName = _.clone(filter);
	item.name = form.getFieldValue(FormField.name) ?? null;
	item.page = 1;
	return item;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null }
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.length !== 0 ? data.map((item, index) => (
			<tr key={ item.id }>
			  <td>{ ++index }</td>
			  <td>{ item?.nameKy }</td>
			  <td>{ item?.nameRu }</td>
			  <td>
				<Flex gap="small">
				  { access && access.methodPut && (
					<Tooltip title={ t('general.edit') }>
					  <Button className='btn_edit' onClick={ () => {
						openAddModal(item)
					  } } type="primary" shape="circle" icon={ <EditOutlined/> }/>
					</Tooltip>
				  ) }
				  { access && access.methodDelete && (
					<Tooltip title={ t('general.delete') }>
					  <Button className='btn_edit' danger onClick={ () => {
						onDeleteOwnershipTypes(item)
					  } } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
					</Tooltip>
				  ) }
				</Flex>
			  </td>
			</tr>
		  )) :
		  <tr>
			<td colSpan={ 4 }>
			  <EmptyData/>
			</td>
		  </tr>
		}
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('titles.type_of_ownership') } // форма владения
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary">{ t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntDirectoryInfoName)
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterByNameHB onSearch={ searchHandleClick }
											 onReset={ () => {
											   clearFields();
											   searchHandleClick()
											 } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
		width={ 700 }
	  />
	  <AddOwnershipTypesModal
		ownershipType={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== 0 ? onEditOwnershipTypes : onAddOwnershipTypes }
	  />
	  { contextHolder }
	</>
  )
}
